import { throttle } from '../../../common/utils';

import overlay from './overlay';
import popup from './popup';

const initialize = () => {

    popup.initialize();

    overlay.initialize();

    $(window).on(
        'resize:horizontally',
        throttle(
            () => {
                overlay.cleanUp();
                overlay.initialize();

                popup.handleResize();
            },
            50
        )
    );
};

export default {
    initialize,
};

